import React from "react";
import "./Blogs.css";

const Blogs = () => {
  return (
    <section className="container bg-success mt-3 pt-3 pb-3">
      <article>
        <h1 className="text-center text-uppercase font-monospace mt-5 fw-bold">
          1.Difference between Javascript and NodeJS
        </h1>
        <div className="w-75 ms-auto me-auto font-monospace text-white fs-5">
          <ul>
            <h2 className="fw-bold">JavaScript:</h2>
            <li>
              Javascript is a programming language that is used for writing
              scripts on the website.{" "}
            </li>
            <li> Javascript can only be run in the browsers.</li>
            <li> It is basically used on the client-side.</li>
            <li>
              {" "}
              Javascript is capable enough to add HTML and play with the DOM.{" "}
            </li>
            <li> Javascript is used in frontend development.</li>
            <li>
              {" "}
              It is the upgraded version of ECMA script that uses Chrome’s V8
              engine written in C++.{" "}
            </li>
          </ul>
          <ul>
            <h2 className="fw-bold">NodeJS:</h2>
            <li>NodeJS is a Javascript runtime environment.</li>
            <li>
              We can run Javascript outside the browser with the help of NodeJS.
            </li>
            <li>It is mostly used on the server-side.</li>
            <li>Nodejs does not have capability to add HTML tags.</li>
            <li>Nodejs is used in server-side development.</li>
            <li>Nodejs is written in C, C++ and Javascript.</li>
          </ul>
          <br />
        </div>
      </article>
      <article>
        <h1 className="text-center text-uppercase font-monospace mt-5 fw-bold">
          2.When should you use node js and when should you use mongodb?
        </h1>
        <div className="w-75 ms-auto me-auto font-monospace text-white fs-5">
          Any project requires a programming environment and a runtime library
          that can build and/or interpret your code and provide basic
          programming tools and support. Nodejs is a Javascript programming
          language tool. So, if you want to develop a Javascript standalone
          program or server, you can employ nodejs. <br />
          <br />
          If program requires persistent data storage, we'll almost certainly
          need to use a database. There are numerous well-known databases. One
          such database is MongoDB. Different databases have various strengths
          and applications. Choosing the correct database for your project is a
          separate matter.
        </div>
      </article>
      <article>
        <h1 className="text-center text-uppercase font-monospace mt-5 fw-bold">
          3.Differences between sql and nosql databases.
        </h1>
        <div className="w-75 ms-auto me-auto font-monospace text-white fs-5">
          <strong>SQL:</strong>
          <br />
          <ul>
            <li>Relational Database Management System (RDBMS)</li>
            <li>These databases have fixed or static or predefined schema</li>
            <li>
              These databases are not suited for hierarchical data storage.
            </li>
            <li>These databases are best suited for complex queries</li>
            <li>Vertically Scalable</li>
            <li>Tables with fixed rows and columns</li>
          </ul>
          <br />
          <strong>NoSQL:</strong>
          <br />
          <ul>
            <li>Non-relational or distributed database system.</li>
            <li>They have dynamic schema</li>
            <li>
              These databases are best suited for hierarchical data storage.
            </li>
            <li>These databases are not so good for complex queries</li>
            <li> Horizontally scalable</li>
            <li>
              {" "}
              Document: JSON documents, Key-value: key-value pairs, Wide-column:
              tables with rows and dynamic columns.
            </li>
          </ul>
        </div>
      </article>
      <article>
        <h1 className="text-center text-uppercase font-monospace mt-5 fw-bold">
          4.What is the purpose of jwt and how does it work?
        </h1>
        <p className="w-75 ms-auto me-auto font-monospace text-white fs-5">
          JWT (JSON Web Token) is an open standard that allows two parties—a
          client and a server—to share security information. JSON items,
          containing a set of claims, are encoded in each JWT. JWTs use a
          cryptographic technique to ensure that the claims cannot be changed
          after the token has been issued.
          <br /> <br />
          JWTs are used as a secure way to authenticate users and share
          information. A private key, or secret, is used by the issuer to sign
          the JWT. It is difficult for unauthenticated sources to guess the
          signing key and attempt to change the claims.
          <br /> <br /> A JWT is a string made up of three parts, separated by
          dots (.), and serialized using base64. In the most common
          serialization format, compact serialization, the JWT looks something
          like this: xxxxx.yyyyy.zzzzz.
        </p>
      </article>
    </section>
  );
};

export default Blogs;
